import React from 'react';
import { formatNumber } from '../../utilities/helpers';

const AudiencePreview = props => {
  return (
    <div className="Audience_summary">
      <div className="Audience_summary_container">
      <span className="Audience_summary_container_first-content">
       <strong>{formatNumber(props.audiencePreviewData.audienceUniques)}</strong> Customer ID's,
       <br/>
       of which <strong>{formatNumber(props.audiencePreviewData.filtered_deviceId_addressable)}</strong> have consented to providing their Advertising ID.
     </span>
     <br/>
     <span className="Audience_summary_container_second-content">
       from a total of <strong>{formatNumber(props.audiencePreviewData.total)}</strong> {props.clientName} customers.
     </span>
      </div>
    </div>
  );
};

export default AudiencePreview;
